import { CLONE_WARNING_MESSAGE } from 'asset-actions-lib-forms/constants/formCloning';
const {
  NOT_CLONE_WORKFLOWS_AND_GDPR,
  NOT_CLONE_WORKFLOWS,
  NOT_CLONE_GDPR
} = CLONE_WARNING_MESSAGE;

/**
 * Taken from https://git.hubteam.com/HubSpot/submissions-ui/blob/3765824bb210d7f8fb69ba9adc433fa1eab89a17/submissions-ui/static/js/utils/FormCloningUtils.ts#L11
 */
export const getCloneWarningMessage = ({
  isBusinessUnitEnabled,
  isDifferentBusinessUnit,
  formHasWorkflows
} = {}) => {
  if (isBusinessUnitEnabled) {
    if (formHasWorkflows) {
      if (isDifferentBusinessUnit) {
        return NOT_CLONE_WORKFLOWS_AND_GDPR; // #1
      } else {
        return NOT_CLONE_WORKFLOWS; // #2
      }
    } else {
      if (isDifferentBusinessUnit) {
        return NOT_CLONE_GDPR; // #3
      }
    }
  } else {
    if (formHasWorkflows) {
      return NOT_CLONE_WORKFLOWS; // #4
    }
  }
  return null;
};